import { Grid, Icon } from "@mui/material";
import React from "react";
import SecureImage from "../atoms/SecureImage";
import { Link } from "react-router-dom";
import { linkByComponent } from "helpers/utils/utilities";
import { getDefaultImageByType } from "components/Cards/MainProductCard";
import ChipsPreview from "../atoms/ChipsPreview";
import TrophyChip from "../atoms/TrophyChip";
import cx from "classnames";
import { getAchievementTypeKey } from "pages/achievements/helpers";

const ComponentProfileCard = ({
  type,
  title,
  slug,
  subTitle,
  iconValueList = [],
  description,
  data,
  t,
}) => {
  return (
    <Grid
      container
      className="border rounded-10 mt-3"
      columnSpacing={2}
      rowSpacing={1}
      py={1}
    >
      <Grid item xs={3}>
        <SecureImage
          type={type}
          placeholder={getDefaultImageByType(type)}
          src={null}
          height="150px"
          width="100%"
          containerClasses="w-full"
          title={data?.title}
        />
      </Grid>
      <Grid item xs={9}>
        <Link
          to={linkByComponent(type, slug)}
          className="c-primary text-truncate text-decoration-none"
        >
          <h2 className="fs-22 fs-18--mob">{title}</h2>
        </Link>
        <h4>{subTitle}</h4>
        <p
          className="text-truncate-2 fs-14 description"
          dangerouslySetInnerHTML={{ __html: description }}
        />
        <Grid
          container
          item
          xs={12}
          className="flex items-center mt-1"
          columnGap={1}
          rowGap={1}
        >
          {iconValueList
            ?.filter((d) => Boolean(d))
            ?.map(
              (
                {
                  icon,
                  value,
                  onClick = () => {},
                  sm = "auto",
                  iconProps = {},
                  classes: c,
                  img,
                },
                i
              ) => (
                <Grid
                  key={i}
                  sm={sm}
                  className={cx(c, "flex items-center tracking-tight mr-2")}
                >
                  {!!icon ? (
                    <Icon
                      component={icon}
                      fontSize="small"
                      className="c-primary cursor-pointer"
                      {...iconProps}
                      onClick={onClick}
                    />
                  ) : !!img ? (
                    <img src={img} className="object-cover w-20 h-20" alt="" />
                  ) : null}

                  <p className="ml-1 fs-12">{value}</p>
                </Grid>
              )
            )}
        </Grid>
        <ChipsPreview
          items={Object.values(data?.skills || {})}
          limit={5}
          maxWidth={200}
        />
      </Grid>
      <Grid item xs={5} mb={1}>
        <TrophyChip
          image={data?.achievement?.achievement_image}
          points={data?.achievement?.achievement_points}
          subTitle={getAchievementTypeKey(data?.achievement?.achievement_type)}
          title={data?.achievement?.achievement_name}
          t={t}
        />
      </Grid>
      <Grid item xs={7}>
        <h3 className="c-primary">Verified Skills</h3>
        <ChipsPreview
          items={Object.values(data?.skills || {})}
          maxWidth={200}
        />
      </Grid>
    </Grid>
  );
};

export default ComponentProfileCard;
